// import { convertHexToRGB as rgba } from 'helpers/theme'

// Colors must not be used directly in components, but they should be (re)assigned here instead
export default {
    // Override global or define new theme specific colors here
}
